import React, { useEffect, useState } from 'react';
import {
  getCurrentMaintenanceNotice,
  subscribeToMaintenance
} from '../utils/maintenance';
import './MaintenanceNotice.css';

export const MaintenanceNotice = ({ message, className = '' }) => {
  if (!message) return null;

  return (
    <div
      className={`scheduled-maintenance-notice ${className}`.trim()}
      role="alert"
      aria-live="assertive"
    >
      {message}
    </div>
  );
};

const MaintenanceBanner = () => {
  const [notice, setNotice] = useState(getCurrentMaintenanceNotice);

  useEffect(() => subscribeToMaintenance(setNotice), []);

  return (
    <MaintenanceNotice
      className="scheduled-maintenance-banner"
      message={notice?.message}
    />
  );
};

export default MaintenanceBanner;
